export default [
    {
        id: 1,
        title: "Airbnb",
        coverImg: "airbnb.webp",
        route: "airbnb",

    },
    {
        id: 2,
        title: "GitHub",
        coverImg: "github.webp",
        route: "github",
    },
    {
        id: 3,
        title: "Truecaller",
        coverImg: "truecaller.webp",
        route: "truecaller",
    },
    {
        id: 4,
        title: "Booking",
        coverImg: "booking.webp",
        route: "booking",
    },
    {
        id: 5,
        title: "Dropbox",
        coverImg: "dropbox.webp",
        route: "dropbox",
    },
    {
        id: 6,
        title: "Cash app",
        coverImg: "cashapp.webp",
        route: "cashapp",
    }
    ,
    {
        id: 7,
        title: "Slack",
        coverImg: "slack.webp",
        route: "slack",
    },
    {
        id: 8,
        title: "Fitbit",
        coverImg: "fitbit.webp",
        route: "fitbit",
        
    }
    ,
    {
        id: 9,
        title: "Strava",
        coverImg: "strava.webp",
        route: "strava",
        
    }
    ,
    {
        id: 10,
        title: "Buffer",
        coverImg: "buffer.webp",
        route: "buffer",
        
    }
    ,
    {
        id: 11,
        title: "Todoist",
        coverImg: "todoist.webp",
        route: "todoist",
        
    }
]